import React from 'react';
import TechnicalInformationCardIssuesListItem from './TechnicalInformationCardIssuesListItem';

export default class TechnicalInformationCardIssuesList extends React.Component {

    onItemClick = item => {
        // TODO (maybe in the future): navigate to the step.
    }

    render() {
        let issues = this.props.issues.getCategorizedByStep()

        return (
            <div className="configuration-editor-issues-list">
                {issues.map((item, idx) => (
                    <React.Fragment key={idx}>
                        <TechnicalInformationCardIssuesListItem item={item} onClick={() => this.onItemClick(item)}/>
                    </React.Fragment>
                ))}
            </div>
        )
    }
}